<template>
  <section id="reach-us" class="blank-home-section reach-us" aria-labelledby="reach-us-title">
    <p class="blank-home-section__watermark" aria-hidden="true"><span>x89</span>Reach</p>

    <div class="reach-us__content">
      <header class="reach-us__intro">
        <h2 id="reach-us-title">Let’s start a conversation.</h2>
        <p>Call, connect with us online, or send through a meeting request.</p>
      </header>

      <div class="reach-us__actions">
        <article class="reach-us__panel reach-us__panel--call">
          <PhoneComponent :data-dictionary="phoneData" />
          <p class="reach-us__helper">{{ helperData.callHelpCard.message }}</p>
        </article>

        <article class="reach-us__panel reach-us__panel--socials" aria-labelledby="reach-us-socials-title">
          <h3 id="reach-us-socials-title">Find 0xeightnine Teams online</h3>
          <SocialsComponent :socials="socials" />
        </article>

        <article class="reach-us__panel reach-us__panel--faq">
          <FAQComponent :faq-data="helperData.faq" />
        </article>

        <article class="reach-us__panel reach-us__panel--newsletter">
          <NewsLetters />
        </article>

        <div class="reach-us__details reach-us__panel" :class="{ 'reach-us__details--open': meetingOpen }">
          <button
            class="reach-us__summary"
            type="button"
            aria-controls="meeting-details-content"
            :aria-expanded="meetingOpen"
            @click="meetingOpen = !meetingOpen"
          >
            <span>Book a meeting</span>
            <span class="reach-us__summary-icon" aria-hidden="true">+</span>
          </button>
          <div id="meeting-details-content" class="reach-us__details-content" :aria-hidden="!meetingOpen">
            <AppointmentComponent :data-dictionary="appointmentData" />
            <p class="reach-us__helper">{{ helperData.appointmentHelpCard.message }}</p>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import home from '@/data/home.json';
import helperData from '@/data/contact.json';
import PhoneComponent from '@/components/global/PhoneChild.vue';
import AppointmentComponent from '@/components/global/AppointmentChild.vue';
import SocialsComponent from '@/components/contact/socialsComponent.vue';
import FAQComponent from '@/components/contact/FAQComponent.vue';
import NewsLetters from '@/components/contact/newsLetters.vue';

export default {
  name: 'ContactUsSection',
  components: {
    PhoneComponent,
    AppointmentComponent,
    SocialsComponent,
    FAQComponent,
    NewsLetters,
  },
  data() {
    return {
      helperData,
      meetingOpen: false,
      phoneData: {
        title: home.mobile.title.charAt(0).toUpperCase() + home.mobile.title.slice(1),
        number: home.mobile.number,
      },
      appointmentData: {
        title: home.appointment.title.charAt(0).toUpperCase() + home.appointment.title.slice(1),
        meetingTypes: home.appointment.meeting_types,
      },
      socials: home.contact.socials.reduce((links, social) => {
        links[social.type] = social.details;
        return links;
      }, {}),
    };
  },
};
</script>
